export default {
  topInput:{}, //トップ画面の受付番号、電話番号
  getAllResponseData:"" , // 検索して取得した結果を保持するstate
  urlParams:{},
};
